import { render, staticRenderFns } from "./EditProjectStatus.vue?vue&type=template&id=3924915e"
import script from "./EditProjectStatus.vue?vue&type=script&lang=js"
export * from "./EditProjectStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports